import {Inject, Injectable, Renderer2, DOCUMENT} from '@angular/core';


@Injectable({
  providedIn: 'root'
})
export class ScriptService {

  constructor(
    @Inject(DOCUMENT) private document: Document
  ) { }

  /**
   * Append the JS tag to the Document Body.
   * @param renderer The Angular Renderer
   * @param src The path to the script
   * @returns the script element
   */
  public loadJsScript(renderer: Renderer2, src: string): HTMLScriptElement {
    const script = renderer.createElement('script');
    script.type = 'text/javascript';
    script.src = src;
    script.onerror = () => console.error(`Failed to load script: ${src}`);
    if (!this.document.querySelector(`script[src="${src}"]`)) {
      renderer.appendChild(this.document.body, script);
    }
    return script;
  }
}
